import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {Checkbox, Layout} from '@phonectas/unifon-ui-kit';

interface MrcFiltersProps {
    filters: Record<string, boolean>;
    onFilterChange: (name: string, value: boolean) => void;
}

const MrcFilters: React.FC<MrcFiltersProps> = ({filters, onFilterChange}) => {
	const [t] = useTranslation();

	const options = useMemo(() => [
		{
			label: t('MRCs failed'),
			checked: filters['mrc_is_failed'] ?? false,
			name: 'mrc_is_failed',
		},
		{
			label: t('MRCs rejected'),
			checked: filters['mrc_is_rejected'] ?? false,
			name: 'mrc_is_rejected',
		},
		{
			label: t('MRCs sent'),
			checked: filters['mrc_is_sent'] ?? false,
			name: 'mrc_is_sent',
		},
		{
			label: t('MRCs signed'),
			checked: filters['mrc_is_signed'] ?? false,
			name: 'mrc_is_signed',
		},
		{
			label: t('SMS failed'),
			checked: filters['sms_is_failed'] ?? false,
			name: 'sms_is_failed',
		},
		{
			label: t('SMS sent'),
			checked: filters['sms_is_sent'] ?? false,
			name: 'sms_is_sent',
		},
	], [t, filters]);

	return (
		<Layout>
			{
				options.map((option) => (
					<Checkbox
						key={option.name}
						label={option.label}
						checked={option.checked}
						toggle
						name={option.name}
						onChange={(e) => onFilterChange(option.name, e.target.checked)}
					/>
				))
			}
		</Layout>
	);
}

export default MrcFilters;